import { useState, useEffect } from "react";
import { isAdmin, hasPermission, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { ConversionFactorsTable } from "../../../components/Admin/ConfigForms/ConversionFactorsTable";
import { useLanguage, useSite } from "../../../contexts";
import { useAuth } from "../../../hooks";
import { Permission } from "../../../api";
import { Header, Segment, Icon } from "semantic-ui-react";
import "./ConversionFactors.scss";

const permissionController = new Permission();

export function ConversionFactors() {
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const [siteSelected, setSiteSelected] = useState(null);
  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { site } = useSite();

   const { translations } = useLanguage();
    const t = (key) => translations[key] || key;

  useEffect(() => {
    setSiteSelected(site);
  }, [site]);

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role, accessToken]);

  if (
    isMaster(role) ||
    isAdmin(role) ||
    hasPermission(permissionsByRole, role._id, "configure", "view")
  ) {
    return (
      <div className="conversion-factors-page">
        <Segment className="conversion-factors-page__title">
          <Header as="h1">{t("conversion_factors")}</Header>
        </Segment>
        {!siteSelected ? (
          <div className="no-site-warning">
            <Icon name="warning sign" size="big" />
            <p>{t("select_company_site_from_header")}</p>
          </div>
        ) : (
          <ConversionFactorsTable site={siteSelected} />
        )}
      </div>
    );
  } else {
    return <ErrorAccessDenied />;
  }
}
